import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'assets/sass/app.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import App from 'app';
import reportWebVitals from './reportWebVitals';
import 'app/core/services/interceptorsService';
import 'app/core/services/yupService';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('ois-app')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
